import ContentContainer from './ContentContainer';
import clsx from 'clsx';
import '../scss/yettel-content.scss';

interface Props {
  children: React.ReactNode;
  noPadding?: boolean;
}

const Content: React.FC<Props> = ({ children, noPadding }) => {
  return (
    <main
      className={clsx(
        'yettel-content d-flex',
        noPadding && 'yettel-content--no-padding'
      )}
    >
      <ContentContainer>{children}</ContentContainer>
    </main>
  );
};

export default Content;
